import { Component, OnInit } from '@angular/core';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserData } from 'src/app/models/user.model';

interface PrivacySettings {
  profileVisibility: 'public' | 'friends' | 'private';
  allowMessages: 'everyone' | 'friends' | 'none';
  showOnlineStatus: boolean;
}

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {
  userData: UserData;
  privacySettings: PrivacySettings = {
    profileVisibility: 'public',
    allowMessages: 'everyone',
    showOnlineStatus: true
  };
  
  firestore = new FirebaseTSFirestore();
  auth = new FirebaseTSAuth();
  isLoading = false;

  constructor(private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.loadPrivacySettings();
  }

  loadPrivacySettings() {
    const userId = this.auth.getAuth().currentUser?.uid;
    if (userId) {
      this.isLoading = true;
      this.firestore.getDocument({
        path: ["Users", userId],
        onComplete: result => {
          const data = result.data();
          this.userData = data as UserData;
          this.privacySettings = {
            profileVisibility: data?.privacySettings?.profileVisibility || 'public',
            allowMessages: data?.privacySettings?.allowMessages || 'everyone',
            showOnlineStatus: data?.privacySettings?.showOnlineStatus ?? true
          };
          this.isLoading = false;
        },
        onFail: err => {
          console.error('Erreur lors du chargement des paramètres:', err);
          this.snackBar.open('Erreur lors du chargement des paramètres de confidentialité', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      });
    }
  }

  updatePrivacySettings() {
    const userId = this.auth.getAuth().currentUser?.uid;
    if (userId) {
      this.isLoading = true;
      this.firestore.update({
        path: ["Users", userId],
        data: { privacySettings: this.privacySettings },
        onComplete: () => {
          this.snackBar.open('Paramètres de confidentialité mis à jour', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        },
        onFail: err => {
          console.error('Erreur lors de la mise à jour:', err);
          this.snackBar.open('Erreur lors de la mise à jour des paramètres', 'Fermer', {
            duration: 3000
          });
          this.isLoading = false;
        }
      });
    }
  }

  isFriend(userId: string): boolean {
    return this.userData?.followers?.includes(userId) && 
           this.userData?.following?.includes(userId);
  }
}
